import React, { useState } from 'react';
import { money } from '../hooks';

function Slider({ id, label, value, min, max, step = 1, format, onChange }) {
  const pct = ((value - min) / (max - min)) * 100;
  return (
    <div className="slider">
      <div className="slider__top">
        <label htmlFor={id}>{label}</label>
        <output htmlFor={id}>{format(value)}</output>
      </div>
      <input
        id={id}
        type="range"
        min={min}
        max={max}
        step={step}
        value={value}
        style={{ '--pct': `${pct}%` }}
        onChange={(e) => onChange(Number(e.target.value))}
      />
    </div>
  );
}

export default function Calculator() {
  const [missed, setMissed] = useState(6);
  const [ticket, setTicket] = useState(32);
  const [wouldOrder, setWouldOrder] = useState(60);

  const monthly = missed * 30 * (wouldOrder / 100) * ticket;

  return (
    <section className="section light" id="missed-calls">
      <div className="wrap calc">
        <div className="calc__copy" data-reveal>
          <p className="eyebrow">The cost of a busy line</p>
          <h2 className="h2">
            Your phone rings hardest when you can least <em>pick it up.</em>
          </h2>
          <p className="lead lead--dark">
            Friday at 7pm, the tandoor is full and there's a line at the counter. The phone rings
            again. Most callers who hit voicemail don't leave a message. They order somewhere else.
          </p>
          <p className="muted">Move the sliders to match your restaurant.</p>
        </div>

        <div className="calc__card" data-reveal>
          <Slider
            id="missed"
            label="Calls you miss on a typical day"
            value={missed}
            min={1}
            max={40}
            format={(v) => v}
            onChange={setMissed}
          />
          <Slider
            id="ticket"
            label="Average phone order"
            value={ticket}
            min={10}
            max={120}
            format={(v) => `$${v}`}
            onChange={setTicket}
          />
          <Slider
            id="would-order"
            label="Missed callers who meant to order"
            value={wouldOrder}
            min={10}
            max={100}
            step={5}
            format={(v) => `${v}%`}
            onChange={setWouldOrder}
          />
          <div className="calc__result">
            <span>Revenue walking out the door</span>
            <strong>
              {money(monthly)}
              <small>/month</small>
            </strong>
            <span className="calc__year">{money(monthly * 12)} a year, based on your numbers</span>
          </div>
        </div>
      </div>
    </section>
  );
}
